import { PRICING_ADJUSTMENT_TITLE } from '@mortgage-pos/types'
import { LOCK_EXTENSION_ADJUSTMENT_TITLE } from './buildExtensionMarginAdjustment'
import { FEES_IN_ADJUSTMENT_TITLE } from './buildFeesInMarginAdjustment'
import { PRICING_EXCEPTION_ADJUSTMENT_TITLE } from './calculatePricingExceptionPercentage'

// RatesService adjustments that set adjustedFinalPrice for Loan Estimate Section A
const PRICE_ADJUSTMENT_TITLES = new Set<string>([
  PRICING_EXCEPTION_ADJUSTMENT_TITLE,
  FEES_IN_ADJUSTMENT_TITLE,
  LOCK_EXTENSION_ADJUSTMENT_TITLE,
  PRICING_ADJUSTMENT_TITLE,
])

export function hasPriceAdjustment(
  adjustments?: ReadonlyArray<{ title?: string | null } | null> | null
): boolean {
  return (adjustments ?? []).some((adjustment) =>
    PRICE_ADJUSTMENT_TITLES.has(adjustment?.title ?? '')
  )
}
